export const siteInfo = {
  name: "凪光在线",
  tagline: "您值得信赖的首选平台，提供流畅稳定的在线体验",
  description: "凪光在线是您值得信赖的首选平台，提供流畅稳定的在线体验。本页汇集凪光在线的核心功能介绍、快速入口、常见问题解答与最新动态，帮助新老用户轻松上手，全面了解凪光在线的服务优势与使用技巧。",
  url: "https://phuucr.cn",
  logo: "凪光在线",
  email: "support@phuucr.cn",
  phone: "400-888-6666",
  address: "中国广东省深圳市南山区科技园路88号",
  foundingYear: "2020",
  socialMedia: {
    weibo: "https://weibo.com/nagihikari",
    wechat: "nagihikari_official",
  },
};

export const stats = {
  totalUsers: "500万+",
  dailyActive: "80万+",
  satisfaction: "98.6%",
  serviceYears: "6年",
};